import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Autocomplete.module.css'
import _ from 'lodash'
import {Util} from 'reactstrap'
import Utils from '../../utils/Utils'

const {mapToCssModules, deprecated, warnOnce} = Util


const propTypes = {
    children: PropTypes.node,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string,
    value: PropTypes.any,
    id: PropTypes.string,
    infoText: PropTypes.string,
    onSelect: PropTypes.func,
    onSelectCode: PropTypes.func,
    onSelectDescription: PropTypes.func,
    customFilter: PropTypes.func,
    onValidate: PropTypes.func,
    innerRef: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
        PropTypes.string
    ]),
    className: PropTypes.any,
    suggestions: PropTypes.any.isRequired,
    styleErrorMessage: PropTypes.string,
    spanStyle: PropTypes.object,
    cssModule: PropTypes.object,
    errorMessage: PropTypes.string,
    showSuggestions: PropTypes.bool,
    descriptionField: PropTypes.string,
    suggestionField: PropTypes.string,
    noSuggestions: PropTypes.string
}

const defaultProps = {
    type: 'text',
    autoComplete: 'off',
    noSuggestions: 'Nessun suggerimento disponibile',
    field: '',
    activeSuggestion: 0,
    positionstartsearch: 1,
    placeholder: '',
}

export default class Autocomplete extends Component {

    constructor(props) {
        super(props)

        this.convertKeysToLowerCase = (obj) => {
            var output = {}
            for (let i in obj) {
                if (Object.prototype.toString.apply(obj[i]) === '[object Object]') {
                    output[i.toLowerCase()] = this.convertKeysToLowerCase(obj[i])
                } else if (Object.prototype.toString.apply(obj[i]) === '[object Array]') {
                    output[i.toLowerCase()] = []
                    output[i.toLowerCase()].push(this.convertKeysToLowerCase(obj[i][0]))
                } else {
                    output[i.toLowerCase()] = obj[i]
                }
            }
            return output
        }

        this.parseSuggestion = (suggestions) => {
            if (typeof suggestions === 'string') {
                return JSON.parse(suggestions)
            } else {
                return this.convertKeysToLowerCase(suggestions)
            }
        }

        this.state = {
            firstSuggestion: null,
            hidden: true,
            icon: true,
            className: this.props.className,
            // The active selection's index
            activeSuggestion: 0,
            // The suggestions that match the user's input
            filteredSuggestions: [],
            // Whether or not the suggestion list is shown
            showSuggestions: false,
            showNoSuggestion:true,
            value: this.props.value,
            timeout: null,
            hasChanged: false
        }
        this.onBlurInput = this.onBlurInput.bind(this)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // only update chart if the data has changed
        if (prevProps.value !== this.props.value) {
            this.setState({
                className: this.removeErrorClass(),
                errorMessage: '',
                styleErrorMessage: 'none',
                value: this.props.value
            })
            if (this.props.onValidate) {
                let ret = this.props.onValidate()
                if (ret) {
                    if (ret === true) {
                        this.setState({className: this.addErrorClass()})
                    } else if (typeof (ret) === 'string') {
                        this.setState({
                            className: this.addErrorClass(),
                            errorMessage: ret,
                            styleErrorMessage: 'inline'
                        })
                    }
                }
            }
        }
        if (this.props.disabled && this.state.showSuggestions) {
            this.setState({showSuggestions: false})
        }
    }


    removeErrorClass = () => {
        if (typeof (this.state.className) === 'string') {
            this.state.className = "txtInput"
        } else if (Array.isArray(this.state.className)) {
            if (!Utils.regexIndexOf(this.state.className, 'errorBorder', -1)) this.state.className.splice(Utils.regexIndexOf(this.state.className, 'errorBorder', 1))
            if (Utils.regexIndexOf(this.state.className, 'txtInput', -1)) this.state.className.push("txtInput")
        }
        return this.state.className
    }

    addErrorClass = () => {
        if (typeof (this.state.className) === 'string') {
            this.state.className = styles.errorBorder
        } else if (Array.isArray(this.state.className)) {
            if (!Utils.regexIndexOf(this.state.className, 'txtInput', -1)) this.state.className.splice(Utils.regexIndexOf(this.state.className, 'txtInput', 1))
            if (Utils.regexIndexOf(this.state.className, 'errorBorder', -1)) this.state.className.push(styles.errorBorder)
        }
        return this.state.className
    }


    getDescription = () => {
        return this.state.value ? this.props.descriptionField ? this.state.value[this.props.descriptionField] : this.state.value : ''
    }

    componentDidMount() {

    }

    onBlurInput(){

        setTimeout(() => {
            this.setState({showSuggestions: false})
        }, 300);

        let that = this
        if(typeof that.state.value !== 'object'){
            this.setState({value: "",showNoSuggestion:false})
            this.invokeChange("")
        }
    }

    invokeChange = (value) => {
        if (this.props.onChange) {
            this.props.onChange(this.props.field, {
                target: {value: value}
            })
        }
    }

    // Event fired when the input value is changed
    onChange = e => {

        const {suggestions} = this.props
        const value = e.currentTarget.value

        if (value == '') {
            if (this.props.onChange) {
                this.props.onChange(this.props.field, {
                    target: {value: value}
                })
            }
        } else {
            if (this.state.timeout) {
                clearTimeout(this.state.timeout)
            }
            this.state.timeout = setTimeout(() => this.invokeChange(value), 500)
        }

        if (value && value.toLowerCase().trim().length >= this.props.positionstartsearch) {
            let userInputParsed = value.toLowerCase().trim()
            // Filter our suggestions that don't contain the user's input

            let filteredSuggestions = []
            if (suggestions) {
                let field = this.props.descriptionField

                if (this.props.suggestionField)
                    field = this.props.suggestionField

                let custFilterFun = this.props.customFilter
                filteredSuggestions = _.filter(suggestions, function (suggestion) {

                    let suggDescription = suggestion
                    if (field) {
                        suggDescription = suggestion[field]
                    }

                    if (custFilterFun) {
                        return suggDescription && suggDescription.toLowerCase().match(userInputParsed) && custFilterFun(suggestion)
                    } else {
                        return suggDescription && suggDescription.toLowerCase().match(userInputParsed)
                    }
                })
            }

            this.setState({
                hasChanged: true,
                firstSuggestion: filteredSuggestions.length > 0 ? filteredSuggestions[0] : null,
                filteredSuggestions,
                showSuggestions: true,
                showNoSuggestion: true,
                value: e.currentTarget.value,
                activeSuggestion: 0
            })
        } else {
            this.setState({
                showSuggestions: false,
                value: e.currentTarget.value,
                activeSuggestion: 0
            })
        }
    }

    handleOnSelect = (_, suggestion) => {

        clearTimeout(this.state.timeout)

        this.setState({firstSuggestion: null, showSuggestions: false, value: suggestion})

        if (this.props.onChange) {
            this.props.onChange(this.props.field, {
                target: {value: suggestion}
            })
        }

        if (this.props.onSelect) {
            this.props.onSelect(suggestion)
        }

        if (this.props.onSelectCode) {
            this.props.onSelectCode(suggestion[this.props.keyField], this.props.field)
        }

        if (this.props.onSelectDescription) {
            this.props.onSelectDescription(suggestion[this.props.descriptionField])
        }
    }

    // Event fired when the user presses a key down
    onKeyDown = e => {
        let {activeSuggestion, filteredSuggestions} = this.state

        // User pressed the enter key, update the input and close the
        // suggestions
        if (e.keyCode === 13 || e.keyCode === 9) {
            if (activeSuggestion >= filteredSuggestions.length) {
                activeSuggestion = 0
            }
            if (this.state.hasChanged) {
                this.handleOnSelect(null, filteredSuggestions[activeSuggestion])
            }
        }
        // User pressed the up arrow, decrement the index
        else if (e.keyCode === 38) {
            if (activeSuggestion === 0) {
                return
            }

            //this.elementInViewPort(`suggestion${activeSuggestion}`)
            this.setState({activeSuggestion: activeSuggestion - 1})
        }
        // User pressed the down arrow, increment the index
        else if (e.keyCode === 40) {
            if (activeSuggestion + 1 === filteredSuggestions.length) {
                return
            }

            //this.elementInViewPort(`suggestion${activeSuggestion}`)
            this.setState({activeSuggestion: activeSuggestion + 1})
        }
    }

    render() {
        const {
            cssModule,
            type,
            state,
            tag,
            innerRef,
            infoText,
            infoTextControlClass,
            placeholder,
            normalized,
            model,
            onValidate,
            spanStyle,
            ...attributes
        } = this.props
        const {filteredSuggestions} = this.state

        if (!this.state.className) {
            this.state.className = ''
        }

        if (Utils.regexIndexOf(this.state.className, 'errorBorder', -1)) {
            this.removeErrorClass()
        }


        let suggestionsListComponent

        let that = this

        if (this.state.showSuggestions) {
            if (filteredSuggestions.length) {
                suggestionsListComponent = (
                    <ul
                        id={this.props.id ? this.props.id + '_autocompleteSuggestions' : 'autocompleteSuggestions'}
                        className={styles.suggestions}
                        style={{
                            position: 'relative',
                            zIndex: '1',
                            textAlign: 'left',
                            border: '3px solid #1b7ea9',
                            backgroundColor: '#ffffff',
                            opacity: this.props.disabled ? '0.5' : '',
                            cursor: this.props.disabled ? "not-allowed" : ""
                        }}
                    >
                        {filteredSuggestions.map((suggestion, index) => {
                            return (
                                <li
                                    id={`suggestion${index}`}
                                    className={
                                        index === this.state.activeSuggestion
                                            ? styles.suggestionSelected
                                            : styles.suggestionActive
                                    }
                                    onClick={e => that.handleOnSelect(e, suggestion)}
                                >
                                    {this.props.descriptionField ? suggestion[this.props.descriptionField] : suggestion}
                                </li>
                            )
                        })}
                    </ul>
                )
            } else {
                suggestionsListComponent = (
                    <div className={styles.noSuggestions}>
                        <span style={{display:this.state.showNoSuggestion?"":"none"}}>{this.props.noSuggestions}</span>
                    </div>
                )
            }
        }

        const classes = mapToCssModules(
            classNames(
                this.state.className,
                'autocomplete'
            ),
            cssModule
        )

        let styleRuntime = ''
        this.state.filteredSuggestions.length > 0 && this.state.showSuggestions
            ? (styleRuntime = '1px solid #1b7ea9')
            : (styleRuntime = '3px solid #1b7ea9')

        return (
            <Fragment>
                <input
                    {...attributes}
                    ref={innerRef}
                    className={["txtInput", classes, "elemento-visualizzazione", this.props.required ? styles.placeholder : "", this.props.addclass? this.props.addclass : ""].join(" ")}
                    autoComplete={this.props.autoComplete}
                    id={this.props.id ? this.props.id : 'inputSuggestions'}
                    type="text"
                    onKeyDown={this.onKeyDown}
                    onChange={this.onChange}
                    onBlur={this.onBlurInput}
                    placeholder={this.props.required ? this.props.placeholder + "*" : this.props.placeholder}
                    value={this.getDescription()}
                />
                {!this.props.disabled && this.props.infoText && !this.state.showSuggestions && (
                    <span className={styles.mandatory}>
                        {this.props.infoText}
                    </span>
                )}
                {!attributes.disabled && suggestionsListComponent}
            </Fragment>
        );
    }
}

Autocomplete.propTypes = propTypes
Autocomplete.defaultProps = defaultProps

